import { PaymentPartnersController } from './paymentPartners.controller';
import template from './paymentPartners.html';

export const paymentPartnersComponent = {
  name: 'paymentPartners',
  restrict: 'E',
  template,
  controller: PaymentPartnersController,
  controllerAs: 'vm',
  bindings: {
    model: '=',
    form: '<'
  }
};
